module.exports = __webpack_public_path__ + "img/auth-reject.de240166.svg";